import { ICellRendererParams } from 'ag-grid-community';
import { IEVMTransaction } from 'src/types';
import { weiToEthBigInt, isMongoLong } from 'src/utils/number';

export const AmountCellRenderer = (params: ICellRendererParams) => {
  const tx = params.data as IEVMTransaction;
  if (!tx) return '';

  // Handle ERC20 tokens
  if (tx.type === 'erc20' && typeof tx.amount === 'number') {
    if (tx.amount === 0) return '0';
    const decimals = tx.tokenMetadata?.decimals
      ? parseInt(tx.tokenMetadata.decimals)
      : 18;
    const formattedAmount = (tx.amount / Math.pow(10, decimals)).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
      },
    );
    return formattedAmount;
  }

  // Handle native ETH (MongoDB Long or number) with BigInt precision
  if (typeof tx.amount === 'number' || isMongoLong(tx.amount)) {
    const ethAmount = weiToEthBigInt(tx.amount);
    if (ethAmount === '0') return '0 ETH';
    return `${parseFloat(ethAmount).toFixed(8)} ETH`;
  }

  return '0 ETH';
};
